'use client'
import { jsx } from 'react/jsx-runtime';
import '@dynamic-labs/sdk-api-core';
import '../../shared/logger.js';
import { getChainIcon } from '../../shared/utils/functions/chain/getChainIcon.js';
import '@dynamic-labs/wallet-connector-core';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import '../../utils/constants/values.js';
import 'react';
import '@dynamic-labs/iconic';
import '../../context/ViewContext/ViewContext.js';
import '../../shared/consts/index.js';
import { Icon } from '../Icon/Icon.js';

const ChainIcon = ({ chain, chainName }) => {
    const ChainIconComponent = getChainIcon(chainName);
    return (jsx(Icon, { size: 'small', children: (chain === null || chain === void 0 ? void 0 : chain.icon) ? (jsx("img", { src: chain.icon, alt: `${chain.name} icon` })) : (jsx(ChainIconComponent, {})) }));
};

export { ChainIcon };
